<section *ngIf="isTileDetailPanel">
  <div class="ptl-ddp-wrapper" [style.background-image]="'url(' + panelData[0]?.tileDetails?.detailBGUrl + ')'">
    <div class="pt-ddp-container" [ngClass]="dynamicClassName">
      <div class="ptl-ddp-title" [ngClass]="setIntelDisplayOneFont ? 'intelOne-headline':''">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_title"></p>
      </div>
      <div class="ptl-ddp-subtitle" [ngClass]="{'intelOne-display': setIntelDisplayOneFont}">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_subtitle"></p>
      </div>
    </div>
  </div>
</section>
<!-- 
Border card ptl-ddp-wrapper -->
<section
  *ngIf="((detailsPageName === 'ptl-aiexperience' || detailsPageName === 'ptl-battery') && isPantherLakeStd)||((detailsPageName === 'ptl-aiexperience'|| detailsPageName === 'ptl-battery'|| detailsPageName === 'ptl-gaming' || detailsPageName === 'ptl-performance') && isPantherLake12Xe)">
  <div class="ptl-borderddp-wrapper" [style.background-image]="'url(' + panelData[0]?.tileDetails?.detailBGUrl + ')'" >
    <div class="ptl-borderddp-container" [ngClass]="dynamicClassName">
      <div class="ptl-borderddp-title" [ngClass]="setIntelDisplayOneFont ? 'intelOne-headline':''">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_title"></p>
      </div>
      <div class="ptl-borderddp-subtitle" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':''" *ngIf="panelData[0]?.tileDetails?.tr_subtitle">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_subtitle"></p>
      </div>
      <div class="ptl-borderddp-card" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':''">
        <ul>
          <li *ngFor="let item of panelData[0]?.tileDetails?.titleArray;" [innerHTML]="item?.tr_title"></li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section *ngIf="detailsPageName === 'ptl-softwarebundle'">
    <div id="software_bundle">
        <div id="bundlePreTitle" class="software-bundle-pretitle"  [class.intelOne-display]="setIntelDisplayOneFont" [innerHTML]="panelData[0].tileDetails?.tr_title1"></div>
        <div class="softwareBundleInfo" style="background-image: url({{panelData[0].tileDetails?.detailBGUrl}});">
            <img class="bundle_bgImage" [src]="panelData[0].tileDetails?.detailBGUrl" alt="sb_panel_bg">
            <div class="softwareBundleDdpcontent">
                <div id="sbPanelTitle" class="panel_title" [ngClass]="setIntelDisplayOneFont ? 'intelOne-headline':''" [innerHTML]="panelData[0].tileDetails?.tr_title"></div>
                <div class="card_content">
                    <div id="sbDDPSubtitle" class="sb_panel_subtitle"  [class.intelOne-display]="setIntelDisplayOneFont"  [innerHTML]="panelData[0].tileDetails?.tr_subtitle"></div>
                </div>
                <div id="bundle_badges" class="sb-panel-badge">
                    <img [src]="panelData[0].tileDetails?.badgeUrl" alt="proc_badge">
                    <div class="inline_separator"></div>
                    <img [src]="panelData[0].tileDetails?.badgeUrl1" alt="proc2_badge">
                </div>
                <div id="sbPanelhead" class="panel_title sb_ddp_subhead" [class.intelOne-display]="setIntelDisplayOneFont" [innerHTML]="panelData[0].tileDetails?.tr_subtitle1"></div>
                <!-- <div > -->
                    <div class="adobe_card" *ngFor="let item of panelData[0].tileDetails?.titleArray">
                        <div class="adobe_section">
                        <img [src]="item.imgUrl" alt="adobe_badge">
                        <div  class="adobe_title" [class.intelOne-display]="setIntelDisplayOneFont" [innerHTML]="item.tr_title"></div>
                        </div>
                    </div>
                <!-- </div> -->
                <div class="card_content">
                    <div id="sbDDPSubtitle" class="sb_panel_legal sb_panel_subtitle"  [class.intelOne-display]="setIntelDisplayOneFont"  [innerHTML]="panelData[0].tileDetails?.tr_subtitle2"></div>
                </div>
            </div>
        </div>
        <!-- <div id="ptlPanelLegal" *ngIf="panel.subtitle2" class="ptl_legal">
            
        </div> -->
    </div>
</section>
<section *ngIf="detailsPageName === 'ptl-battlefield6'">
  <div class="ptl-ddp-wrapper" [ngClass]="dynamicClassName">
    <video *ngIf="panelData[0]?.tileDetails?.detailBGUrl?.endsWith('.mp4')" class="ptl-ddp-video" autoplay muted loop playsinline [src]="panelData[0]?.tileDetails?.detailBGUrl" poster="assets/images/ptl-battlefield6-bg.png"></video>
    <img [src]="panelData[0]?.tileDetails?.adlobimgUrl" class="ptl-image" alt="ptl-genaralAdlob">
    <div class="pt-ddp-container" [ngClass]="dynamicClassName">
      <div class="ptl-ddp-title" [ngClass]="[setIntelDisplayOneFont ? 'intelOne-headline':'', !setIntelDisplayOneFont ? 'other-lang-font-style' : '', nonItalicLangArray.includes(language) ? 'non-italic-lang-cls':'']">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_title"></p>
      </div>
      <div class="ptl-ddp-subtitle" [ngClass]="{'intelOne-display': setIntelDisplayOneFont}">
        <p [innerHTML]="panelData[0]?.tileDetails?.tr_subtitle"></p>
      </div>
    </div>
  </div>
</section>
